import axios from 'axios';
import rateLimit from 'axios-rate-limit';

/**
 * Produce an axios wrapper to limit requests.
 * @returns {RateLimitedAxiosInstance}
 */
export const axiosRateLimit = () => {
  let create = axios.create();
  let config = { maxRequests: 1, perMilliseconds: 1000, maxRPS: 1, };
  return rateLimit(create, config);
};
